import * as React from 'react'
import type { SyncGuide } from '../../../shared/domain/guides/types.no-deps'
import type { CommonDeps } from '../base/CommonDeps'
import type { RenderCachedImage } from '../image/WithCachedImage'
import { GuidePresentationWithParentInfo } from './GuidePresentationWithParentInfo'
import type { ParentInfo, WorkflowGuideExecution } from './Model'

interface Props {
    deps: CommonDeps
    guideExecution: WorkflowGuideExecution
    onClickGuideParentInfo: (parentInfo: ParentInfo) => void
    renderCachedImage: RenderCachedImage
    renderWorkflowGuideExecution: (guide: SyncGuide<'workflow'>) => React.ReactElement<unknown>
}

/**
 * A component that displays a viewable workflow guide.
 */
export function WorkflowGuidePresentation(props: Props) {
    return (
        <GuidePresentationWithParentInfo
            deps={props.deps}
            guideParentInfo={props.guideExecution.parentInfo}
            onClickGuideParentInfo={props.onClickGuideParentInfo}
            renderCachedImage={props.renderCachedImage}
        >
            {props.renderWorkflowGuideExecution(props.guideExecution.guide)}
        </GuidePresentationWithParentInfo>
    )
}
